import { AgentConnectorsPanel } from '@/features/agents/AgentConnectorsPanel';
import { AgentCatalogsPanel } from '@/features/agents/AgentCatalogsPanel';
import { AgentKnowledgePanel } from '@/features/agents/AgentKnowledgePanel';
import { AgentEmailPanel } from '@/features/agents/AgentEmailPanel';
import { useAgentContext } from '@/features/agents/AgentLayout';

/**
 * Configuration tab (spec 0012): the connectors, catalogs, knowledge, and
 * email/Slack panels. Each panel renders its own Card and owns its inline error
 * handling. The agent is resolved once by the layout from the URL slug; panels
 * key off its UUID (spec 0013). Knowledge panel added by spec 0014.
 */
export function AgentConfigPage() {
  const { agentId } = useAgentContext();

  return (
    <div className="space-y-6" data-testid="agent-config-page">
      <AgentConnectorsPanel agentId={agentId} />
      <AgentCatalogsPanel agentId={agentId} />
      <AgentKnowledgePanel agentId={agentId} />
      <AgentEmailPanel agentId={agentId} />
    </div>
  );
}
